import { z } from 'zod';

import { ActivityDocumentSchema } from './activity-document';
import { ActivityFileActionSchema, ActivityType } from './activity-type';
import { ActivityUserSchema } from './activity-user';

const BaseActivitySchema = z.object({
  id: z.string(),
  siteIds: z.array(z.string()),
  createdAt: z.date(),
});

const UserFileActivitySchema = BaseActivitySchema.merge(
  z.object({
    type: z.literal(ActivityType.USER_FILE),
    action: ActivityFileActionSchema,
    user: ActivityUserSchema,
    document: ActivityDocumentSchema,
    details: z
      .object({
        field: z.string(),
        old: z.string(),
        new: z.string(),
      })
      .nullable(),
  }),
);

export const ActivitySchema = z.discriminatedUnion('type', [
  UserFileActivitySchema,
]);

export type Activity = z.infer<typeof ActivitySchema>;
